import { MetersController } from "@quest/murka-games-behavior-panther/dist";


/**
 * MetersControllerGame class handles the meters for the base game
 *  ex. win meter, win tickup etc.
 */
export class MetersControllerGame extends MetersController {
//

}
